import * as actionTypes from "./actionTypes";

const initialState = {
  version: null,
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
      return { ...state, isLoading: true };
    case actionTypes.GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        version: action.payload.version,
      };
    case actionTypes.GET_REJECTED:
      return { ...state, isLoading: false };

    default:
      return state;
  }
}
